import { RedirectDto } from "@intelligems/ig-types";

export const getSpecificRedirectsUtil = (
  redirects: RedirectDto[],
  redirectType: "template" | "theme" | "url"
) => {
  switch (redirectType) {
    case "template":
      return redirects
        .filter((redirect) => redirect.isTemplateTest)
        .sort((a, b) => (a.group ?? 0) - (b.group ?? 0));
    case "theme":
      return redirects.filter((redirect) => redirect.isThemeTest);
    case "url":
      return redirects.filter(
        (redirect) => !redirect.isTemplateTest && !redirect.isThemeTest
      );
    default:
      return redirects;
  }
};

export const getSpecificVariationRedirectsUtil = (
  redirects: RedirectDto[],
  redirectType: "template" | "theme" | "url",
  variationId: string
) => {
  return getSpecificRedirectsUtil(redirects, redirectType).filter(
    (redirect) => redirect.variationId === variationId
  );
};
